<template>
  <div class="forgot-password">
    <div class="pb-3 forgot-password-title">
      <h1>
        <router-link :to="{ name: 'Login' }" class="btn btn-link">
          <i class="bi bi-arrow-left"></i>
        </router-link>
        忘記密碼?
      </h1>
    </div>
    <div class="card forgot-password-card">
      <div class="card-body p-4">
        <form @submit.prevent="submitForm">
          <div class="mb-3">
            <label for="forgotPasswordEmail1" class="form-label"
              >請輸入您的帳號信箱，會將重置密碼寄送於您的信箱中</label
            >
            <input
              v-model="form.email"
              type="email"
              class="form-control"
              id="forgotPasswordEmail1"
              placeholder="請輸入信箱"
              required
            />
          </div>
          <div class="text-danger text-center mb-3" v-if="errMsg">
            {{ errMsgInfo }}
          </div>
          <button
            type="submit"
            class="btn btn-info rounded-pill forgot-password-submit"
          >
            寄送
          </button>
        </form>
      </div>
    </div>
    <small class="pt-3 d-block text-center fw-light">
      Client： <span class="text-primary">{{ clientName }}</span>
      <span class="ps-3">
        Version： <span class="text-primary">{{ version }}</span>
      </span>
    </small>
    <small class="p-3 d-block text-center fw-light"
      >© 2021 - {{ new Date().getFullYear() }} 釦釘資訊工作室 All rights
      reserved.</small
    >
  </div>
</template>

<script>
import { auth } from '@/http/api/auth.js'
import { mapState, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'ForgotPassword',
  data () {
    return {
      version: process.env.PACKAGE_VERSION,
      form: {
        email: null
      }
    }
  },
  computed: {
    ...mapState(['errMsg']),
    ...mapGetters(['clientName', 'errMsgInfo'])
  },
  methods: {
    ...mapMutations(['Loaded', 'Loading', 'SetErrMsg', 'ClearErrMsg']),
    submitForm () {
      const vm = this
      vm.Loading()
      auth
        .forgotPassword(vm.form)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.SetErrMsg({
              狀態: '寄送成功，請前往您的信箱查收信件'
            })
          } else {
            vm.SetErrMsg(data.errMsg)
          }
          vm.Loaded()
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.Loaded()
        })
    }
  }
}
</script>

<style lang="scss">
.forgot-password {
  width: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  &-title {
    max-width: 360px;
    width: 90%;
    margin: auto;
    color: #fff;
    a {
      font-size: 24px;
      color: #fff;
      padding-left: 1rem;
      padding-right: 1rem;
      transition: padding 0.3s ease-in-out;
      &:hover {
        color: #fff;
        padding-left: 0;
        padding-right: 2.5rem;
      }
    }
  }
  &-card {
    max-width: 360px;
    width: 90%;
    margin: auto;
  }
  &-submit {
    color: #fff;
    width: 100%;
    transition: box-shadow 0.3s ease-in-out;
    background: $linear-gradient;
    box-shadow: 0px 4px 4px $shadow-color;
    &:hover {
      color: #fff;
      box-shadow: 0px 7px 7px $shadow-color;
    }
  }
}
</style>
